import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import InputTextField from "../Pages/BusinessProfile/TextField";
import { FiSearch, FiFilter } from "react-icons/fi";
import { InputAdornment } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import useCheckPermission, {
  customSnackBar,
  isBusinessRolePermissionAllowed,
} from "../utils";
import { useSelector } from "react-redux";
const NavBarHeading = ({
  backtostafflising,
  selectedBusines,
  handleMoreOptionsClick,
  rowData,
  record,
  data,
  setRowData,
  buttonText,
  link,
  OnSearch,
}) => {
  const location = useLocation();
  const history = useHistory();
  const [selectedValue, setSelectedValue] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("Select option");
  const [permission, setPermissions] = useState(null);
  const businessId = JSON.parse(localStorage.getItem("businessRecord"));
  // const selectedBusiness = useSelector((state)=>state.Business.selectedBusiness);
  // Handler to update the selected value when the user selects an option
  const handleSelectChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleBusinesSelection = () => {
    if (selectedBusines === null) {
      alert("Plese Select/Add the Business");
    } else {
      history.push(`/add-staff/${selectedBusines?.id}`);
    }
  };
  const handleOptionChange = (option) => {
    if (option === "Booking") {
      history.push("/scheduler/create_booking");
    } else if (option === "Event") {
      history.push("/scheduler/create_event");
    } else if (option === "Break") {
      history.push("/scheduler/create_break");
    }
    setSelectedOption(option);
    setIsOpen(false); // Close the dropdown after selection
  };

  // const result = useCheckPermission("Staff", "create").then((res) => {

  //     setPermissions(res);

  // });
  useEffect(() => {
    if (permission === false && location.pathname.includes("/staff-list")) {
      customSnackBar("You have not a Permssion To Add Staff");
    }
  }, [permission]);

  const options = ["Booking", "Event", "Break"];
  return (
    <>
      {location.pathname.includes("/all-listing") ||
      location.pathname.includes("/staff-list") ||
      location.pathname.includes("/all-services") ||
      location.pathname.includes("/subscribe") ||
      location.pathname.includes("/notes") ||
      location.pathname.includes("/scheduler/create_booking") ||
      location.pathname.includes("/scheduler/create_event") ||
      location.pathname.includes("/scheduler/create_break") ||
      location.pathname.includes("/all-customer") ||
      location.pathname.includes("/Profile") ||
      location.pathname.includes("/our-faculty") ||
      location.pathname.includes("/edit-map") ||
      location.pathname.includes("/add-new-business") ||
      location.pathname.includes(`/business-profile/${businessId?.id}`) ||
      location.pathname.includes("/edit-business-name") ||
      location.pathname.includes("/add-owner-details") ||
      location.pathname.includes("/select-address") ||
      location.pathname.includes("/add-business-schedular") ||
      location.pathname.includes("/team") ||
      location.pathname.includes("/business/") ||
      location.pathname.includes("/edit-owner-detail") ||
      location.pathname.includes("/department") ||
      location.pathname.includes("/users") ||
      location.pathname.includes(`providerScheduler/:id`) ||
      location.pathname.includes("/edit-business-address") ||
      location.pathname.includes("/edit-industry-type") ||
      location.pathname.includes("/edit-business-type") ||
      location.pathname.includes("/edit-business-website") ||
      location.pathname.includes("/staff-profile-view") ? (
        <div className="col-md-12 px-2 py-1 bg-white second_nav">
          <div className="row">
            <div className="col-md-6">
              <div className="flex_in_calendex_bar">
                <div>
                  {location.pathname.includes("/staff-profile-view") ? (
                    <span onClick={backtostafflising} className="px-2">
                      {" "}
                      <i className="fas fa-arrow-left"></i>
                    </span>
                  ) : (
                    <img
                      className="img-fluid img_size_cal"
                      src="/images/cal.png"
                      alt="no-data"
                    />
                  )}
                </div>
                <div className="px-2 ">
                  {location.pathname.includes("/staff-list") ||
                  location.pathname.includes("/our-faculty") ? (
                    <p className="m-0 p-0">
                      <strong> Staff </strong>
                    </p>
                  ) : location.pathname.includes("/staff-profile-view") ? (
                    <p className="m-0 px-0 pt-1 staff_prof_font">
                      {" "}
                      Staff Profile{" "}
                    </p>
                  ) : location.pathname.includes("/all-listing") ? (
                    <p className="m-0 p-0"> Bookings </p>
                  ) : location.pathname.includes("/business/") ? (
                    <p className="m-0 p-0"> Manage Business </p>
                  ) : location.pathname.includes("/team") ? (
                    <p className="m-0 p-0"> Manage Team </p>
                  ) : location.pathname.includes("/department") ? (
                    <p className="m-0 p-0"> Manage Department </p>
                  ) : location.pathname.includes("/users") ? (
                    <p className="m-0 p-0"> Manage Users </p>
                  ) : location.pathname.includes("/all-customer") ? (
                    <p className="m-0 p-0"> Customer </p>
                  ) : location.pathname.includes("/add-business-schedular") ? (
                    <p className="m-0 p-0"> Business Opening Hour </p>
                  ) : location.pathname.includes("/all-services") ? (
                    <p className="m-0 p-0"> Services </p>
                  ) : location.pathname.includes("/add-new-business") ? (
                    <p className="m-0 p-0"> Add Business </p>
                  ) : location.pathname.includes("/select-address") ? (
                    <p className="m-0 p-0"> Create New Business </p>
                  ) : location.pathname.includes("/add-owner-details") ? (
                    <p className="m-0 p-0"> Add Business Detail </p>
                  ) : location.pathname.includes("/scheduler/create_booking") ||
                    location.pathname.includes("/scheduler/create_event") ||
                    location.pathname.includes("/scheduler/create_break") ? (
                    <p className="m-0 py-0 ps-3">
                      <strong> Create </strong>
                    </p>
                  ) : location.pathname.includes("/subscribe") ? (
                    <p className="m-0 p-0"> Products </p>
                  ) : location.pathname.includes("/edit-business-name") ||
                    location.pathname.includes("/edit-business-address") ||
                    location.pathname.includes("/edit-industry-type") ||
                    location.pathname.includes("/edit-owner-detail") ||
                    location.pathname.includes("/edit-business-type") ||
                    location.pathname.includes("/edit-map") ||
                    location.pathname.includes("/edit-business-website") ? (
                    <p className="m-0 p-0"> Manage Business Profile </p>
                  ) : location.pathname.includes(
                      `/business-profile/${businessId?.id}`
                    ) ? (
                    <p className="m-0 p-0"> Business Profile </p>
                  ) : location.pathname.includes("/Profile") ? (
                    <p className="m-0 p-0"> Manage Profile </p>
                  ) : location.pathname.includes("/notes") ? (
                    <p className="m-0 p-0"> Notes </p>
                  ) : location.pathname.includes(
                      `providerScheduler/${selectedBusines?.id}`
                    ) ? (
                    <p className="m-0 p-0"> Scheduler </p>
                  ) : (
                    <p className="m-0 p-0">
                      {" "}
                      Name For This Page Not Added Yet{" "}
                    </p>
                  )}
                </div>
                {location.pathname.includes("/business/") ||
                location.pathname.includes("/users") ||
                location.pathname.includes("/department") ||
                location.pathname.includes("/team") ? (
                  <div className="pt-1">
                    {" "}
                    <div className="d-flex align-items-center me-2  ms-3 mt-1 mb-2">
                      <InputTextField
                        id="input-with-icon-textfield-search"
                        placeholder="Search Here.."
                        onChange={(e) =>
                          OnSearch(e.target.value, data, setRowData)
                        }
                        sx={{
                          width: "100%",
                          maxWidth: "300px",
                          "& .MuiOutlinedInput-root": {
                            borderRadius: 1,
                            backgroundColor: "#fff",
                            height: "30px",
                            border: "1px solid #E0E3E7",
                            transition:
                              "border-color, background-color, box-shadow",
                            "&:hover": {
                              backgroundColor: "transparent",
                            },
                          },
                        }}
                        startAdornment={
                          <InputAdornment position="start">
                            <FiSearch
                              style={{ color: "#b2b2b2", fontSize: "20px" }}
                            />
                          </InputAdornment>
                        }
                        endAdornment={
                          <InputAdornment position="start">
                            <img src="/images/Vector (2).svg" alt="no-data" />
                          </InputAdornment>
                        }
                      />
                    </div>
                  </div>
                ) : null}
                {(location.pathname.includes("/scheduler/create_booking") ||
                  location.pathname.includes("/scheduler/create_event") ||
                  location.pathname.includes("/scheduler/create_break")) && (
                  <div>
                    <div
                      className="dropdown-container"
                      style={{
                        position: "relative",
                        display: "inline-block",
                        marginLeft: "30px",
                      }}
                    >
                      <div
                        className="dropdown-header"
                        style={{
                          borderRadius: "6px",
                          border: "1px solid #D7D7D7",
                          background: "#FFF",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          width: "141px",
                          padding: "0",
                          cursor: "pointer", // Add cursor pointer
                        }}
                        onClick={toggleDropdown}
                      >
                        <span
                          style={{
                            color: "#585858",
                            fontFamily: "Inter",
                            fontSize: "12px",
                            fontStyle: "normal",
                            marginLeft: "10px",
                            fontWeight: 600,
                          }}
                        >
                          {location.pathname.includes(
                            "/scheduler/create_booking"
                          )
                            ? "Booking"
                            : location.pathname.includes(
                                "/scheduler/create_event"
                              )
                            ? "Event"
                            : location.pathname.includes(
                                "/scheduler/create_break"
                              )
                            ? "Break"
                            : ""}
                        </span>
                        <div
                          className={`dropdown-icon px-2 ${
                            isOpen ? "open" : ""
                          }`}
                          style={{
                            borderRadius: "0px 7px 7px 0px",
                            background: "#EBEBEB",
                            height: "24px",
                            display: "flex",
                            alignItems: "center",
                            transition: "transform 0.3s ease", // Add transition for smooth icon rotation
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="10"
                            height="6"
                            viewBox="0 0 10 6"
                            fill="none"
                            style={{
                              transform: isOpen
                                ? "rotate(180deg)"
                                : "rotate(0deg)", // Rotate icon based on dropdown state
                            }}
                          >
                            <path
                              d="M1 1L5.1569 5L9 1"
                              stroke="#707070"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                      </div>
                      {isOpen && (
                        <ul
                          className="dropdown-options"
                          style={{
                            listStyle: "none",
                            padding: "0",
                            margin: "0",
                            position: "absolute",
                            minWidth: "140px",
                            top: "100%",
                            left: "0",
                            zIndex: "1",
                            border: "1px solid #D7D7D7",
                            marginTop: "5px",
                            borderRadius: "5px",
                            overflow: "hidden",
                            backgroundColor: "white",
                            // borderRadius: "8px",
                          }}
                        >
                          {options.map((option, index) => (
                            <li
                              key={index}
                              onMouseDown={() => handleOptionChange(option)}
                              style={{
                                marginTop: "5px",
                                marginBottom: "5px",
                                background:
                                  option === selectedOption
                                    ? "#FFD705"
                                    : "#FFF",
                                padding: "4px 9px",

                                cursor: "pointer",
                                userSelect: "none",
                              }}
                            >
                              {option}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="col-md-6 px-4">
              <div className="flex_in_calendex_bar1">
                <div className="px-2">
                  {location.pathname.includes("/our-faculty") ? (
                    permission === true || permission === null ? (
                      <button
                        onClick={() => {
                          handleBusinesSelection();
                        }}
                        className="btn btn-warning button_styling px-4"
                      >
                        <img
                          className="img-fluid img_size_cal_menu"
                          src="/images/addcircle.png"
                          alt="no-data"
                        />{" "}
                        Add
                      </button>
                    ) : null
                  ) : location.pathname.includes("/staff-profile-view/") ? (
                    <span>
                      <button
                        onClick={() => handleMoreOptionsClick()}
                        className="btn btn-warning button_styling px-3"
                      >
                        <img
                          className="img-fluid img_size_cal_menu2"
                          src="/images/calen.png"
                          alt="no-data"
                        />
                        &nbsp;&nbsp;<span className="pt-2"> Schedule</span>
                      </button>
                      <button
                        onClick={
                          () => customSnackBar("We are working on it")
                          // history.push(`/add-staff/${selectedBusines?.id}`)
                        }
                        className="btn btn-warning button_styling px-3 mx-2"
                      >
                        <img
                          className="img-fluid img_size_cal_menu2"
                          src="/images/cale.png"
                          alt="no-data"
                        />
                        &nbsp;&nbsp;<span className="pt-2"> Bookings</span>
                      </button>
                      <button
                        onClick={
                          () => customSnackBar("We are working on it")
                          // history.push(`/add-staff/${selectedBusines?.id}`)
                        }
                        className="btn btn-warning button_styling px-3 mx-2"
                      >
                        <img
                          className="img-fluid img_size_cal_menu2"
                          src="/images/msh.png"
                          alt="no-data"
                        />
                        &nbsp;&nbsp;<span className="pt-2"> Messages</span>
                      </button>
                      <button
                        onClick={
                          () => customSnackBar("We are working on it")
                          // history.push(`/add-staff/${selectedBusines?.id}`)
                        }
                        className="btn btn-warning button_styling px-3 mx-2"
                      >
                        <img
                          className="img-fluid img_size_cal_menu2"
                          src="/images/chat.png"
                          alt="no-data"
                        />
                        &nbsp;&nbsp;<span className="pt-2"> Services</span>
                      </button>
                    </span>
                  ) : location.pathname.includes("/team") ||
                    location.pathname.includes("/department") ||
                    location.pathname.includes("/business/") ||
                    location.pathname.includes("/users") ? (
                    <Button
                      sx={{
                        backgroundColor: "#538dff",
                        height: "30px",
                        borderRadius: "4px",
                        textTransform: "capitalize",
                      }}
                      variant="contained"
                      onClick={() => {
                        const data = {
                          data: record,
                          actionState: "new",
                        };
                        // history.push(`/users?${queryParams.toString()}`);

                        history.push(link, { data });
                      }}
                    >
                      + &nbsp;{buttonText}
                    </Button>
                  ) : null}
                  {/* {location.pathname.includes("/staff-list") && <button onClick={() => history.push(`/add-staff/${selectedBusiness.id}`)} className="btn btn-warning button_styling px-4"><img className="img-fluid img_size_cal_menu" src="../images/addcircle.png" /> Add</button>} */}
                </div>
                {location.pathname.includes("/staff-list") ||
                location.pathname.includes("/our-faculty") ? (
                  <div className="">
                    <img
                      className="img-fluid img_size_cal_menu"
                      src="/images/menu.png"
                      alt="no-data"
                    />
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default NavBarHeading;
